var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 12.9"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.7 11.5c0 .8.6 1.4 1.4 1.4h5.7c.8 0 1.4-.6 1.4-1.4V2.9H.7v8.6zM10 .7H7.5L6.8 0H3.2l-.7.7H0v1.4h10V.7z",
    fill: "#2065b5"
  })));
}
export default SvgDelete;